import pmdCookieCheckout from './pmdCookieCheckout';
var buyButtonsClick = function buyButtonsClick(props) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref.structure;
  pmdCookieCheckout({
    structure: structure
  });
};
export default buyButtonsClick;